import { getApiClient } from "./apiClient";

export type SearchThreadResult = {
  id: string;
  subject?: string;
  summary: string;
  status: "new" | "triage" | "in_progress" | "resolved";
  priority: "low" | "medium" | "high" | "critical";
  updatedAt: string;
  customer?: {
    id: string;
    name?: string;
    email?: string;
  };
};

export type SearchEntityResult = {
  id: string;
  threadId?: string;
  type: "ticket" | "task" | "incident" | "request";
  title: string;
  description: string;
  priority: "low" | "medium" | "high" | "critical";
  status: "new" | "proposed" | "approved" | "in_progress" | "done";
  updatedAt: string;
};

export type SearchCustomerResult = {
  id: string;
  name?: string;
  email?: string;
  updatedAt: string;
};

export type SearchResults = {
  threads: SearchThreadResult[];
  entities: SearchEntityResult[];
  customers: SearchCustomerResult[];
};

export type SearchResponse = {
  query: string;
  results: SearchResults;
};

export async function searchEverything(
  query: string,
  limit = 5,
  options?: { semantic?: boolean }
) {
  const api = getApiClient();
  const params = new URLSearchParams({ q: query, limit: String(limit) });
  if (options?.semantic) {
    params.set("semantic", "true");
  }
  const response = await api.get<SearchResponse>(`/search?${params.toString()}`);
  return response.data;
}
